import { Box, Paper, Typography } from '@mui/material';
import { SchoolIcon } from 'svg';
import { ClientModel } from 'modules/map/types';

interface Props {
  data: ClientModel;
  onClick: () => void;
  isActive?: boolean;
}
const SchoolCardInfo = (props: Props) => {
  const { isActive, data, onClick } = props;

  return (
    <Paper
      sx={{
        display: 'flex',
        p: 1,
        gap: 2,
        cursor: 'pointer',
        borderRadius: 3,
        border: '0.5px solid',
        borderColor: isActive ? 'primary.main' : 'divider',
      }}
      onClick={onClick}
    >
      <SchoolIcon style={{ height: 48, width: 48, flexShrink: 0 }} />
      <Box>
        <Typography>{data.name}</Typography>
        <Typography variant="caption">
          {[data.addressDetail, data.wardName, data.cityName].join(', ')}
        </Typography>
      </Box>
    </Paper>
  );
};
export default SchoolCardInfo;
